import React, { useState, useContext, useEffect } from "react";
import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core";
import Numeral from "react-numeral";
import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon, StarIcon } from "@heroicons/react/20/solid";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import ReactTooltip from "react-tooltip";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import { calcularFechas } from "./calculoFechas";
import moment from "moment";
import { HttpRequest } from "../../services/httpRequest";
import * as url from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import { calcInteresCorrienteV2, calcularInteresCorrienteTed, calcularInteresCorrienteTem } from "../../utils/creditUser/calcInteresCorriente";
import { calcDescuentoFirmaElectronicaV1, firmaElectronica } from "../../utils/creditUser/calcDctoFirmaElectronica";
import { convertToNumber, isValidNumber } from "../../utils/isValidNumber";

let Tmlv;
const apiClient = new APIClient();

const getTlmv = async () => {
  try {
    let data = await HttpRequest.getTMLV();
    localStorage.setItem('tmlv', JSON.stringify(data.message.data) ?? "{}");
  } catch (error) {
    console.log(error);
    return error;
  }
}

const getInterest = async () => {
  try {
    let currentInterestRate = localStorage.getItem("currentInterestRate");
    if (currentInterestRate && currentInterestRate !== "null") {
      return currentInterestRate;
    }
    let response = await apiClient.get(url.GET_RATES_CURRENT_INTEREST);
    let interest = response.data.data[0].tasa ?? null;
    localStorage.setItem("currentInterestRate", interest);
  } catch (error) {
    console.log(error);
    return error;
  }
};

const PrettoSlider = withStyles({
  root: {
    color: "#7E02FC",
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const fechasOptions = calcularFechas();

const dateLimit1 = fechasOptions.fecha1.format("DD/MM/YYYY");
const dateLimit2 = fechasOptions.fecha2.format("DD/MM/YYYY");
const vence1 = fechasOptions.fecha1.diff(moment(), "days");
const vence2 = fechasOptions.fecha2.diff(moment(), "days");

const timepay = [
  { id: 1, value: vence1 + 1 },
  { id: 2, value: vence2 + 1 },
];

const datepay = [
  {
    id: 1,
    day: fechasOptions.fecha1Day,
    datelimit: dateLimit1,
    value: timepay[0].value,
    expira: `Vence en ${timepay[0].value} días`,
  },
  {
    id: 2,
    day: fechasOptions.fecha2Day,
    datelimit: dateLimit2,
    value: timepay[1].value,
    expira: `Vence en ${timepay[1].value} días`,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function SimulatorRenovar(props) {
  const { updateCreditUser, creditUser } = useContext(CreditUserContext);

  const [Amount, setAmount] = useState(props.default);
  const [selectedMailingLists, setSelectedMailingLists] = useState(datepay[1]);
  const [interest, setInterest] = useState(0);
  const [total, setTotal] = useState(0);
  const [checkFirmaElectronica, setCheckFirmaElectronica] = useState(true);
  const [firmaElectronicaValue, setFirmaElectronicaValue] = useState(0);
  const [dctoFirmaElectronica, setDctoFirmaElectronica] = useState(0);
  const [totalFirmaElectronica, setTotalFirmaElectronica] = useState(0);
  const [mesUsura, setMesUsura] = useState("");
  const [tasaUsura, setTasaUsura] = useState("");
  const [tasaUsuraTmlvRate, setTasaUsuraTmlvRate] = useState("");
  const [discountForReward, setDiscountForReward] = useState(0);



  const maxAmount = props?.maxAmn;
  const minAmount = props?.minAmn;
  const step = props?.step;
  const rewardHistoryAvailable = props?.rewardHistoryAvailable;

  const handleChangeOption = (event) => {
    event.persist();
    const target = event.target;
    let dateSelected = moment(target.innerText, "DD/MM/YYYY");
    let vencimientoEnDias = dateSelected.diff(moment(), "days") + 1;

    setInterest(calculateInterest(Amount, vencimientoEnDias));
    setTotal(calculateTotal(Amount, vencimientoEnDias));

    updateCreditUser({
      requestedAmount: Amount,
      approvedQuota: maxAmount,
      termInDays: vencimientoEnDias,
      totalToPay: total,
      paydayLimit: target.innerText,
      documento: localStorage.getItem('doc'),
      acceptanceDate: moment().format("DD/MM/YYYY"),
      firmaElectronica: firmaElectronicaValue,
      dctoFirmaElectronica: dctoFirmaElectronica,
      tasaInteresCorriente: localStorage.getItem("currentInterestRate"),
      interestRate: interest,
      tipoFirma: checkFirmaElectronica ? 'electronica' : 'fisica',
    });
  };

  const calculateInterest = (amount, vencimientoEnDias) => {
    let tasa = localStorage.getItem("currentInterestRate");
    let tea = localStorage.getItem("currentInterestTea");
    tea = convertToNumber(tea);
    let tasaUsuraTmlv = tasaUsuraTmlvRate;
    tasaUsuraTmlv = parseFloat(tasaUsuraTmlv.replace(',', '.'));
    if (!isValidNumber(tea)) tea = 0;
    //si la tasa efectiva anual de interes corriente es mayor a la tasa de usura de la tasa máxima legal permitida se aplica la tasa de usura de la tasa máxima legal permitida
    if (tea > tasaUsuraTmlv) {
      console.log('Interes corriente tea > tasaUsuraTmlv');
      tea = tasaUsuraTmlv;
      localStorage.setItem("currentInterestTea", tea);
      let tasaNueva = calcCurrentInterestTed(tea);
      localStorage.setItem("currentInterestRate", tasaNueva);
      tasa = tasaNueva;
    }
    const interest2 = calcInteresCorrienteV2(amount, vencimientoEnDias, tasa);
    return interest2;
  }

  const calcCurrentInterestTed = (tea) => {
    let interesCorrienteTea = parseFloat(tea);
    let interesCorrienteTem = calcularInteresCorrienteTem(interesCorrienteTea);
    let interesCorrienteTed = calcularInteresCorrienteTed(interesCorrienteTem);
    return interesCorrienteTed;
  };

  const calculateTotal = (amount, vencimientoEnDias) => {
    if (checkFirmaElectronica) {
      let total = amount + calculateInterest(amount, vencimientoEnDias) + calcFirmaElectronica(amount, vencimientoEnDias);
      if (discountForReward > 0) {
        total = total - discountForReward;
      }
      return total;
    } else {
      let total = amount + calculateInterest(amount, vencimientoEnDias);
      setDctoFirmaElectronica(firmaElectronicaValue);
      return total;
    }
  }

  const calcFirmaElectronica = (amount, vencimientoEnDias) => {
    let _firmaElectronica = firmaElectronicaValue;
    let dctoFirmaElectronica = calcDescuentoFirmaElectronicaV1(amount, vencimientoEnDias);
    let _firmaElectronicaTotal;
    if (dctoFirmaElectronica === _firmaElectronica) {
      setDctoFirmaElectronica(0);
      setTotalFirmaElectronica(_firmaElectronica);
      _firmaElectronicaTotal = _firmaElectronica;
    } else {
      setDctoFirmaElectronica(dctoFirmaElectronica);
      setTotalFirmaElectronica(_firmaElectronica - dctoFirmaElectronica);
      _firmaElectronicaTotal = _firmaElectronica - dctoFirmaElectronica;
    }
    return _firmaElectronicaTotal;
  }

  const handleCheckFirmaElectronica = (event) => {
    setCheckFirmaElectronica(event.target.checked);
  }

  const onChangeSlider = (amount) => {
    setAmount(amount);
    let dateSelected = moment(selectedMailingLists?.datelimit, "DD/MM/YYYY");
    let vencimientoEnDias = dateSelected.diff(moment(), "days") + 1;
    setInterest(calculateInterest(Amount, vencimientoEnDias));
    setTotal(calculateTotal(Amount, vencimientoEnDias));

    updateCreditUser({
      requestedAmount: amount,
      approvedQuota: maxAmount,
      termInDays: vencimientoEnDias,
      totalToPay: total,
      paydayLimit: selectedMailingLists?.datelimit,
      documento: localStorage.getItem('doc'),
      acceptanceDate: moment().format("DD/MM/YYYY"),
      firmaElectronica: firmaElectronicaValue,
      dctoFirmaElectronica: dctoFirmaElectronica,
      tasaInteresCorriente: localStorage.getItem("currentInterestRate"),
      interestRate: interest,
      tipoFirma: checkFirmaElectronica ? 'electronica' : 'fisica',
    });
  }

  const calcDiscountForReward = () => {
    if (rewardHistoryAvailable && rewardHistoryAvailable?.rewardHistoryAvailable) {
      let shortCode = rewardHistoryAvailable?.shortCodeReward;
      let typeReward = String(shortCode).substring(1, 3);
      if (typeReward === '10') {
        let percentage = rewardHistoryAvailable?.rewardHistoryAvailable?.percentDiscount;
        let discountReward = (firmaElectronicaValue * percentage) / 100;
        setDiscountForReward(discountReward);
      }
    }
  }

  useEffect(() => {
    (async () => {
      try {
        await getTlmv();
        let _tmlvData = localStorage.getItem("tmlv");
        if (_tmlvData) {
          try {
            Tmlv = JSON.parse(_tmlvData);
            if (Tmlv) {
              let _time = Tmlv[0]?.date ?? "";
              let _usura = `${Tmlv[0]?.rate}${Tmlv[0]?.percent} ${Tmlv[0]?.text}`;
              setMesUsura(_time);
              setTasaUsura(_usura);
              setTasaUsuraTmlvRate(Tmlv[0]?.rate);
            }
          } catch (error) {
            console.error(error);
          }
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {

      await getInterest();
      //Calcular interes
      let _interest = calculateInterest(Amount, selectedMailingLists.value);
      setInterest(_interest);
    })();
  }, [Amount, interest]);

  useEffect(() => {

    const updateInfoCredit = async () => {

      let dateSelected = moment(selectedMailingLists?.datelimit, "DD/MM/YYYY");
      let vencimientoEnDias = dateSelected.diff(moment(), "days") + 1;

      updateCreditUser({
        requestedAmount: Amount,
        approvedQuota: maxAmount,
        termInDays: vencimientoEnDias,
        totalToPay: total,
        paydayLimit: selectedMailingLists?.datelimit,
        documento: localStorage.getItem('doc'),
        acceptanceDate: moment().format("DD/MM/YYYY"),
        firmaElectronica: firmaElectronicaValue,
        dctoFirmaElectronica: dctoFirmaElectronica,
        tasaInteresCorriente: localStorage.getItem("currentInterestRate"),
        interestRate: interest,
        tipoFirma: checkFirmaElectronica ? 'electronica' : 'fisica',
      });
    }
    updateInfoCredit()
      .then((res) => {
        console.log('Info actualizada!')
      })
      .catch(e => console.log(e))
    calcDiscountForReward();
    //Calcular Total
    let _total = calculateTotal(Amount, selectedMailingLists.value);
    setTotal(_total);

    setFirmaElectronicaValue(firmaElectronica);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total, interest, checkFirmaElectronica, Amount]);


  return (
    <div>
      <div class="relative pt-1">
        <div className="flex justify-between">
          <span className="text-lg font-medium">{props.title}</span>
          <Numeral
            className="text-lg font-medium"
            format={"$0,0"}
            value={Amount}
          />
        </div>
        <PrettoSlider
          value={Amount}
          step={step}
          onChange={(event, vAmnt) => {
            onChangeSlider(vAmnt);
          }}
          defaultValue={Amount}
          max={maxAmount}
          min={minAmount}
        />
      </div>
      <div class={props.class || "relative"}>
        <span className="text-lg font-medium">{props.title2}</span>
        <div className="mt-2 grid gap-y-6 grid-cols-2 gap-x-4">
          {datepay.map((datePay) => (
            <span className="text-sm pl-2">{datePay.day}</span> // Dia de la semana
          ))}
        </div>
        <RadioGroup
          value={selectedMailingLists}
          onChange={setSelectedMailingLists}
          onClick={handleChangeOption}
        >
          <div className="mt-1 grid gap-y-6 grid-cols-2 gap-x-4">
            {datepay.map((datePay) => (
              <RadioGroup.Option
                value={datePay}
                key={datePay.id}
                className={({ checked, active }) =>
                  classNames(
                    checked
                      ? "border-transparent"
                      : "border-purple border-opacity-20",
                    active ? "border-purple ring-1 ring-purple" : "",
                    "relative bg-white border rounded-lg shadow-sm px-5 py-1 flex focus:outline-none"
                  )
                }
              >
                {({ checked, active }) => (
                  <>
                    <span className="flex-1 flex">
                      <span className="flex flex-col">
                        <RadioGroup.Description
                          onClick={handleChangeOption}
                          as="span"
                          className="flex font-medium items-center text-xl cursor-pointer"
                        >
                          {datePay.datelimit} {/* Fecha limite de pago */}
                        </RadioGroup.Description>
                      </span>
                    </span>
                    <CheckCircleIcon
                      className={classNames(
                        !checked ? "invisible" : "",
                        "h-5 w-5 text-purple"
                      )}
                      aria-hidden="true"
                    />
                    <span
                      className={classNames(
                        active ? "border" : "border-2",
                        checked ? "border-purple" : "border-transparent",
                        "absolute -inset-px rounded-lg pointer-events-none"
                      )}
                      aria-hidden="true"
                    />
                  </>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>

        <div className="mt-2 grid gap-y-6 grid-cols-2 gap-x-4">
          {datepay.map((datePayY) => (
            <span className="text-sm pl-2">
              {datePayY.expira}
            </span> /* Vence en x días */
          ))}
        </div>
      </div>
      <div className="mt-4">

        <div className="text-sm flex justify-between">
          <span>Monto solicitado</span>
          <div className="mr-4">
            <Numeral format={"$0,0"} value={Amount} />
          </div>
        </div>
        <div className="text-sm flex justify-between">
        <span>{`Interés corriente (${localStorage.getItem('currentInterestTea') ?? 25}% E.A)`}</span>
          <div className="flex">
            <Numeral format={"$0,0"} value={interest} />
            <InformationCircleIcon
              data-tip="React-tooltip"
              data-for="int"
              className="w-4 h-auto ml-0.5 cursor-pointer"
            />
            <div className="font-bold">
              <ReactTooltip
                place="top"
                id="int"
                type="dark"
                effect="solid"
                className="w-72"
              >
                (Efectivo Anual) sobre el capital adeudado, para {mesUsura} la
                tasa máxima fijada por las autoridades en Colombia es del{" "}
                {tasaUsura}
              </ReactTooltip>
            </div>
          </div>
        </div>
        <div className="font-bold">Costo opcional</div>
        <div className="text-sm flex justify-between gap-1">
          <div className="flex gap-1">
            <input
              id="sign-e"
              name="sign-e"
              required
              type="checkbox"
              className="h-4 w-4 text-purple focus:ring-0 border-tdark rounded cursor-pointer"
              onChange={handleCheckFirmaElectronica}
              checked={checkFirmaElectronica}
            />
            <span>
              Firma electrónica{" "}
              <span className="text-xs">(con descuento aplicado)</span>
            </span>
          </div>
          <div className="flex">
            {
              totalFirmaElectronica > 0 && (
                <>
                  <Numeral format={"$0,0"} value={totalFirmaElectronica} />
                  <InformationCircleIcon
                    data-tip="React-tooltip"
                    data-for="admon"
                    className="w-4 h-auto ml-0.5 cursor-pointer"
                  />
                  <div className="font-bold">
                    <ReactTooltip
                      place="top"
                      type="dark"
                      effect="solid"
                      id="admon"
                      className="w-72"
                    >
                      La Firma Electrónica es el costo opcional que de manera libre
                      y voluntaria es aceptado por ti, posterior a la solicitud y
                      aprobación del crédito. El costo del servicio de Firma
                      Electrónica es un costo fijo de $145.000 pesos al que podemos
                      aplicar un descuento de  ({checkFirmaElectronica === true ? <Numeral format={"$0,0"} value={dctoFirmaElectronica === 0 ? "0" : dctoFirmaElectronica} /> : "0"}) por pronto pago, en caso de
                      que entres en mora este descuento puede cambiar o anularse. Al
                      ser un costo opcional puedes aceptar adquirlo o no. En el caso
                      de que tu solicitud sea aprobada verás una vista que te
                      permitirá elegir usar nuestra Firma Electrónica o conocer el
                      proceso para firmar en físico.
                    </ReactTooltip>
                  </div>
                </>
              )
            }
          </div>
        </div>

        {
          discountForReward > 0 && (
            <>
              <div className="text-sm flex justify-between gap-1">
                <div className="flex gap-1">
                  <span>
                    Dcto firma electrónica{" "}
                    <span className="text-xs">(Recompensa)</span>
                  </span>
                </div>
                <div className="flex">{"- "}
                  <Numeral format={"$0,0"} value={discountForReward} />
                  <StarIcon data-tip="React-tooltip" data-for='reward' className="w-4 h-auto cursor-pointer ml-0.5 text-green" />
                  <ReactTooltip className="font-bold" id="reward" place="top" type="dark" effect="solid">   Este es el descuento de tu recompensa!   </ReactTooltip>
                </div>

              </div>
            </>
          )
        }

        <div className="text-base pt-4 font-medium flex justify-between">
          <span>Total a pagar</span>
          <Numeral format={"$0,0"} value={total} />
        </div>
        <RadioGroup
          value={selectedMailingLists}
          onChange={setSelectedMailingLists}
          className="text-sm flex justify-between"
        >
          <span>Fecha límite de pago</span>
          {datepay.map((datepay) => (
            <RadioGroup.Option
              key={datepay.id}
              value={datepay}
              className={({ checked, active }) =>
                classNames(
                  checked ? "text-tdark" : "hidden",
                  active ? "text-tdark" : "text-tdark"
                )
              }
            >
              {({ checked, active }) => (
                <div>
                  <RadioGroup.Description as="span">
                    {datepay.datelimit}
                  </RadioGroup.Description>
                </div>
              )}
            </RadioGroup.Option>
          ))}
        </RadioGroup>
      </div>
    </div>
  );
}
